module.exports = __webpack_public_path__ + "media/images/area/feature/hokkaido/related/zh-hant_5-dca2dd461f6847a2127a2eb1b2aab860.jpg";